import { useQuery } from "@tanstack/vue-query";
import { getEstadoInventarioAction } from "../actions";
import { computed, onMounted } from "vue";

export function useInventarioQuery() {
  const query = useQuery({
    queryKey: [ "inventario"],
    queryFn: async () => {
      const response = await getEstadoInventarioAction();
      return response.data;
    },
    refetchInterval: 120000, // Refetch cada 2 minutos
    staleTime: 90000,
    placeholderData: (previousData) => previousData
  });
  const inventarioData = computed(() => query.data.value);
  return {
    inventarioData,
    ...query,
  };
}
